import React from 'react';
import TimeSeriesChart, { CHART_COLORS } from './TimeSeriesChart';
import { formatPercent } from './format';
import { hasSwapData, percentSeries } from './series';
import type { Sample } from './types';

interface PanelProps {
  samples: Sample[];
  timestamps: number[];
  sampleCounts: number[];
}

export default function MemoryPanel({ samples, timestamps, sampleCounts }: PanelProps) {
  const memory = percentSeries(samples, (snapshot) => snapshot.mem_usage, {
    id: 'memory',
    label: 'Memory',
    color: CHART_COLORS.primary,
  });

  const swapPresent = hasSwapData(samples);

  const swap = percentSeries(samples, (snapshot) => snapshot.swap_usage, {
    id: 'swap',
    label: 'Swap',
    color: CHART_COLORS.secondary,
  });

  return (
    <>
      <TimeSeriesChart
        title="Memory usage"
        timestamps={timestamps}
        sampleCounts={sampleCounts}
        series={swapPresent ? [memory, swap] : [memory]}
        yMax={100}
        formatValue={formatPercent}
      />

      {/* Only when every sample says null. A current processor sends 0.0 for a
          host with no swap, so a flat zero line is the honest reading there and
          this note only appears against older builds. */}
      {samples.length > 0 && !swapPresent && (
        <p className="system-stats__note">This host has no swap.</p>
      )}
    </>
  );
}
